/**
 * Semantic color tokens. Names mirror the Figma "Semantic colors" frame; each
 * token defaults to a {@link Color} primitive (design system `ds.colors.scss`)
 * and can be repointed per project via `PrevioDesignSystem.install(app, { colors })`.
 */
export enum ColorSemantic {
  TEXT_TITLE_TEMPLATES = 'text-titleTemplates',
  TEXT_TITLE_CARD = 'text-titleCard',
  TEXT_STANDARD = 'text-standard',
  TEXT_ADDITIONAL = 'text-additional',
  TEXT_DISABLED = 'text-disabled',
  TEXT_READ_ONLY = 'text-readOnly',
  TEXT_POSITIVE = 'text-positive',
  TEXT_WARNING = 'text-warning',
  TEXT_NEGATIVE = 'text-negative',
  TEXT_INFO = 'text-info',
  TEXT_LINK = 'text-link',
  TEXT_ON_DARK_BACKGROUND = 'text-onDarkBackground',

  SURFACE_BACKGROUND = 'surface-background',
  CARD_ON_WHITE_BACKGROUND = 'card-onWhiteBackground',
  CARD_ON_GRAY_BACKGROUND = 'card-onGrayBackground',

  TABLE_EVEN = 'table-even',
  TABLE_ODD = 'table-odd',
  TABLE_HOVER = 'table-hover',

  ICON_BRAND = 'icon-brand',
  ICON_STANDARD = 'icon-standard',
  ICON_ADDITIONAL = 'icon-additional',
  ICON_DISABLED = 'icon-disabled',
  ICON_POSITIVE = 'icon-positive',
  ICON_BACKGROUND_POSITIVE = 'icon-background-positive',
  ICON_WARNING = 'icon-warning',
  ICON_BACKGROUND_WARNING = 'icon-background-warning',
  ICON_NEGATIVE = 'icon-negative',
  ICON_BACKGROUND_NEGATIVE = 'icon-background-negative',
  ICON_INFO = 'icon-info',
  ICON_BACKGROUND_INFO = 'icon-background-info',
}
